<mat-sidenav-container autosize style="height: 100%;">
    <mat-sidenav #sidenav [mode]="(isBigTablet$ | async )? 'over' : 'side'" opened="true" class="{{'
        max-width '+(collapseSideNav?'collapsed-size':'')}}" fixedInViewport="true">
        <div class="{{'side-wrapper g-just-flex flex-column '+( collapseSideNav === true?'collapse-menu':'')}}">
            <div class="top-sidenav px-13 py-13"
                style="position: sticky; top: 0px; background-color: var(--mat-sys-surface-container-low); z-index: 10;">
                @if(collapseSideNav){
                <div class="expand" (click)="sideNavService.expandSideNav()" style="padding: 10px;">
                    <mat-icon class="small-icon">
                        chevron_right

                    </mat-icon>
                </div>

                }
                <div class="pb-13">


                    <div class="logowrapper g-just-flex gap-12" style="justify-content: space-between;">
                        <div class="logo-picture g-just-flex"
                        style="flex: 1 0 70%"
                        >
                            <img src="assets/logos/logo.png" alt="e-Likita Logo" class="form-logo" fetchpriority="high"
                                width="80" height="80">


                        </div>
                        <!-- <div class="logo-text">
                            e-Likita
                        </div> -->
                        <div class="shrink" (click)="sideNavService.collapseSideNav()" style="padding: 10px;">
                            <mat-icon class="small-icon">
                                chevron_left
                            </mat-icon>
                        </div>

                    </div>
                </div>
                <!-- <div class="gap"></div> -->
                 <app-organization-switcher
                    [collapsed]="collapseSideNav"
                    (switched)="onOrganizationSwitched()">
                </app-organization-switcher>
                <mat-divider></mat-divider>
            </div>

            <div class="middle-sidenav px-13 pb-13"
            style="padding-top: 0px;"
            >
                <!-- <div style="position: sticky; top: 60px;
                background-color: var(--mat-sys-surface-container-low);
                " class="pt-13">
                </div> -->
                <app-sidemenu></app-sidemenu>
            </div>

            <mat-menu #sideActionsMenu="matMenu">
                <button mat-menu-item [matMenuTriggerFor]="roleSwitcherMenu" [disabled]="!canSwitchRoles">
                    <mat-icon>swap_horiz</mat-icon>
                    <span>Role switcher</span>
                </button>
  <app-hospital-switcher></app-hospital-switcher>
                <button mat-menu-item (click)="openProfile()">
                    <mat-icon>person</mat-icon>
                    <span>Profile</span>
                </button>
                <button mat-menu-item (click)="logout()">
                    <mat-icon>logout</mat-icon>
                    <span>Logout</span>
                </button>
            </mat-menu>

            <mat-menu #roleSwitcherMenu="matMenu">
                @for (role of currentUserRoles; track role) {
                <button mat-menu-item (click)="switchRole(role)">
                    <mat-icon>{{ userChangeForm.value === role ? 'radio_button_checked' : 'radio_button_unchecked'
                        }}</mat-icon>
                  <span>{{ role | roleDisplayName }}</span>
                </button>
                }
            </mat-menu>
            <div class="bottom-sidenav px-13 py-13" style="position: sticky;
                box-sizing: border-box;
                bottom: 0px; background-color: var(--mat-sys-surface-container-low); z-index: 10;">
                <mat-divider></mat-divider>
                <div class="bottom-sidenav-toolbar pt-13 pb-13 "
                    style="position: absolute; width:  stretch; box-sizing: border-box;">
                    <button type="button" class="toolbar-icon-btn" [attr.aria-label]="getThemeLabel()"
                        [title]="getThemeLabel()" (click)="toggleTheme()">
                        <mat-icon>{{ getThemeIcon() }}</mat-icon>
                    </button>

                    <button type="button" class="toolbar-icon-btn" [matMenuTriggerFor]="sideActionsMenu"
                        aria-label="Open sidenav actions" title="Open sidenav actions">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                </div>
                <div class="pb-13"></div>
                <div class="my-profile my-profile--vertical">
                    <div class="picture">
                        <img [src]="getCurrentUserPhotoUrl()" alt="Profile photo" srcset="" loading="lazy">
                    </div>
                    <div class="words">
                        <div class="name">
                            @if ((auth.user | async)?.role === 'doctor') {
                            Dr. {{ getUserDisplayName() }}
                            } @else {
                            {{ getUserDisplayName() }}
                            }
                        </div>
                        <div class="role">
                            @if ((auth.user | async); as currentUser) {
                            @if (currentUser.role === 'patient' && patientHospitalId) {
                            Patient ID: {{ patientHospitalId }}
                            } @else if (currentUser.role === 'patient') {
                            Patient ID unavailable
                            } @else {
                            @if (auth.getCurrentUserSpecialty(); as specialty) {
                            ({{ specialty }})
                            } @else {
({{ currentUser.role | roleDisplayName }})
}
                            }
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </mat-sidenav>
    <mat-sidenav-content>
        <div class="top-menu-strip">
            @if(isBigTablet$ | async){
            <div class="hamburger-menu">
                <mat-icon (click)="sidenav.toggle()">menu</mat-icon>
            </div>
            }

            <div class="links">
                <a (click)="openandC()" title="Use AI assistant">
                    <mat-icon>auto_awesome</mat-icon>

                </a>
                <a>
                    <app-onboarding-setup-bell></app-onboarding-setup-bell>
                </a>
                <a>
                    <app-notification-bell></app-notification-bell>
                </a>
                <a title="Open messaging previews">
                    @if (canUseMessaging) {
  <app-messaging-dropdown-bell></app-messaging-dropdown-bell>
}
                </a>
                <!-- <a>
                    <mat-icon>person</mat-icon>
                </a> -->
            </div>
        </div>
        
        <div class="gap"></div>

        <!-- Fixed Code Blue Emergency Banner -->
        <div *ngIf="activeEmergencyAlert" class="code-blue-banner">
            <div class="code-blue-content">
                <strong>{{activeEmergencyAlert.title}}</strong>
                <span>🚨 {{activeEmergencyAlert.description}}</span>
            </div>
            <button (click)="dismissEmergencyAlert()" class="code-blue-close" aria-label="Close">&times;</button>
        </div>
          <app-info-banner *ngIf="showMissingScheduleBanner"

                         type="warning"
                         title="Action Required"
                         [dismissible]="true"
                         (closed)="dismissScheduleBanner()">
            Your schedule for the upcoming month is incomplete. Please submit your schedule.
        </app-info-banner>
            <div *ngIf="showMissingScheduleBanner"
            class="p-20"></div>

        <div
            [style]="{'margin-right': (isBigTablet$ | async) ? '0px' : '20px', 'margin-left': (isBigTablet$ | async) ? '0px' : '20px', }">
            <div class="breadcrumb-actions mb-20
           g-just-flex flex-between gap-20 flex-wrap
           ">
               <div class="breadcrumbs">
    <app-breadcrumb-navigation></app-breadcrumb-navigation>
    @if (currentHospitalName) {
    <span class="hospital-chip" title="Current hospital">
        <mat-icon class="small-icon">domain</mat-icon>
        {{ currentHospitalName }}
    </span>
    }
</div>
                <div class="actions" [style]="{'margin-right': (isBigTablet$ | async) ? '30px' : '10px'}">
                    <ng-container *ngTemplateOutlet=" topactionsService.topactiontemplate | async"></ng-container>
                </div>
            </div>
            <div class="mt-20" style="max-width: 1450px; margin: auto;">
                <router-outlet>

                </router-outlet>
            </div>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>

<app-aichat></app-aichat>
<app-realtime-alert></app-realtime-alert>